import React from "react";
import featuresbg from "../Assets/featuresbg.png";
import { motion } from "framer-motion";
const featureData = [
  {
    image: require("../Assets/icons/icon1.png"),
    title: "Trade Anything, Anywhere",
    text: "Access every major DEX on Monad through one command.NTB finds the best routes and prices automatically, fast, efficient, unstoppable.",
  },
  {
    image: require("../Assets/icons/icon2.png"),
    title: "Smart Telegram Commands",
    text: "Paste a token address. Get instant Buy, Sell, Limit, and Info options. Smooth, intuitive, and frictionless.",
  },
  {
    image: require("../Assets/icons/icon3.png"),
    title: "Limit Orders Made Simple",
    text: "Set limit buys and sells directly in chat. NTB executes when your price hits, no missed entries, no stress.",
  },
  {
    image: require("../Assets/icons/icon4.png"),
    title: "Accessibility and Rewards",
    text: "Trade from anywhere, anytime, with one-tap Telegram access.Earn referral - rewards and loyalty bonuses as you trade.",
  },
  {
    image: require("../Assets/icons/icon5.png"),
    title: "Real-Time Portfolio Tracking Feature 5",
    text: "Use /position to view holdings, PnL, and performance, live and instant.",
  },
  {
    image: require("../Assets/icons/icon6.png"),
    title: "Security and Safety",
    text: "Every trade runs through MonadScore’s protection engine.Fake tokens and high-risk pairs are flagged before execution.",
  },
  {
    image: require("../Assets/icons/icon7.png"),
    title: "Predictive Intelligence by MonadScore",
    text: "Every trade is backed by real-time analytics and optimized routing, powered by MonadScore.",
  },
  {
    image: require("../Assets/icons/icon8.png"),
    title: "Transparent Fees",
    text: "Flat 0.6 percent fee on every trade. No hidden charges.",
  },
  {
    image: require("../Assets/icons/icon9.png"),
    title: "Instant Withdrawals",
    text: "Withdraw MON or tokens in seconds. Fast, transparent, and gas-optimized.",
  },
  {
    image: require("../Assets/icons/icon10.png"),
    title: "Referral Rewards",
    text: "Share your invite link and earn as your friends trade.Because winning is better when everyone eats.",
  },
];

const Features = () => {
  return (
    <section id="features"
      className="w-full px-4 sm:px-6 md:px-8 py-36 sm:py-24 md:py-48 lg:py-64 text-white"
      style={{
        backgroundImage: `url(${featuresbg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-center mb-12">
          Features
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12">
          {featureData.map((feature, index) => (
            <motion.div
              key={index}
              className="relative border border-white rounded-xl pt-16 px-6 pb-6 flex flex-col items-center text-center"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
            >
              {/* Image in circle overlapping top border */}
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 w-16 h-16 rounded-full border border-white bg-black flex items-center justify-center overflow-hidden z-20">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-10 h-10 object-cover"
                />
              </div>

              {/* Title */}
              <h4
                className="text-lg sm:text-xl mt-4"
                style={{ color: "#F458FF" }}
              >
                {feature.title}
              </h4>

              {/* Text */}
              <p className="text-white mt-2 text-center text-sm sm:text-base">{feature.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
